module.exports = __webpack_public_path__ + "img/C-info-01-mobile.81c5ec29.png";